export default __webpack_public_path__ + "static/media/check_green_icon.0581711f.svg";